import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { capitalize } from 'lodash';
import { useTheme } from '@mui/material/styles';
import { ListItemButton, Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import { useDispatch } from '../../redux/store';
import { onSelectSite } from '../../redux/slices/sites';
import { postDevice, unlinkClockingDevices, linkClockingDevices } from '../../redux/slices/clockings';
import { MIcon } from '../@material-extend';
import { PATH_AUTH } from '../../routes/paths';
import useAuth from '../../hooks/useAuth';

const SitePairingItem = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    features: { clockingsByNfc, showOntimeShiftsList }
  } = useAuth();
  const {
    closest = false,
    isLoading = true,
    isNewDevice = false,
    pairedDevice,
    selected = false,
    site,
    site: { address, city, code, distance, name, postcode, client_name: clientName },
    handleClickSite
  } = props;
  const distanceSimple = distance > 1000 ? `${Math.floor(distance / 1000)}km` : `${distance}m`;

  const handleClick = async (site) => {
    dispatch(onSelectSite(site.id));

    if (isNewDevice) {
      // Association de l'appareil directement en mode web ou si la fonctionnalité n'est pas disponible
      if (!showOntimeShiftsList && (!window.env.isApp || !clockingsByNfc)) {
        const success = await dispatch(postDevice(site.id));
        if (!success) {
          return;
        }
      }

      // Paramétrage des modes de pointages
      navigate(PATH_AUTH.clockingApp.settings);
    } else {
      const device = {
        id: pairedDevice[0].clockingDeviceId,
        ip_address: pairedDevice[0].ip_address,
        location: pairedDevice[0].location
      };
      dispatch(unlinkClockingDevices(pairedDevice[0].siteClockingDeviceId));
      dispatch(linkClockingDevices({ device, siteId: site.id }));
    }
    if (handleClickSite) {
      handleClickSite();
    }
  };

  if (isLoading) {
    return <Skeleton variant="rounded" height={56} />;
  }

  return (
    <ListItemButton data-cy="site-pairing-item" sx={styleListItemButton(selected)} onClick={() => handleClick(site)}>
      <Stack id="pairing-site-name" flexGrow={1}>
        <Typography variant="body1">{name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {code}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {clientName}
        </Typography>
      </Stack>

      {!isMobile && (
        <Stack sx={styleAddressWrapper}>
          <Typography variant="caption" align="right" color="text.secondary">
            {capitalize(address)} {postcode} {city}
          </Typography>
        </Stack>
      )}

      {distance && (
        <Stack direction="column" alignItems="center" justifyContent="center" minWidth={40}>
          <MIcon icon="place" variant={closest ? 'success' : 'secondary'} />
          <Typography variant="caption" color={closest ? 'success.dark' : 'text.secondary'}>
            {distanceSimple}
          </Typography>
        </Stack>
      )}
    </ListItemButton>
  );
};
SitePairingItem.propTypes = {
  closest: PropTypes.bool,
  isLoading: PropTypes.bool,
  isNewDevice: PropTypes.bool,
  pairedDevice: PropTypes.array,
  selected: PropTypes.bool,
  site: PropTypes.object,
  handleClickSite: PropTypes.func
};

const styleListItemButton = (selected) => ({
  backgroundColor: 'white',
  borderRadius: selected ? 1 : 0,
  gap: 3
});

const styleAddressWrapper = {
  flexDirection: { xs: 'column', md: 'row' },
  gap: { xs: 0, md: 0.5 }
};

export default SitePairingItem;
